var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('AdultsHeader'),_c('SeniorsMinistries'),_c('SeniorsChoir'),_c('AdultsPrayer'),_c('GetInTouch'),_c('AboutResources')],1)}
var staticRenderFns = []

export { render, staticRenderFns }